<template>
    <div class="pl-6 container">
        <v-divider v-if="$vuetify.breakpoint.smAndDown" class="mb-6"></v-divider>
        <!-- Produto -->
        <div class="d-flex align-center mb-2 flex-wrap customer-name__text ml-n1 mt-n2">
            <span class="font-weight-normal color--primary">
                <v-icon color="primary" size="30" left class="mr-2 mt-n1">{{ productIcon }}</v-icon>{{ productName }}
            </span>
        </div>

        <!-- Bem -->
        <div class="mt-4">
            <div class="text--advice_friendly customer-info__label-text mr-1 pb-1">
                Bem:
            </div>
            <span class="customer-info__value-text">{{ bemText }}</span>
        </div>
        <!-- Plano -->
        <div class="mb-1">
            <div class="text--advice_friendly customer-info__label-text mr-1 pb-1">
                Plano:
            </div>
            <span class="customer-info__value-text">{{ planoText }}</span>
        </div>
        <!-- Grupo -->
        <div class="mb-1">
            <div class="text--advice_friendly customer-info__label-text mr-1 pb-1">
                Grupo/Cota:
            </div>
            <span class="customer-info__value-text">
                {{ displayGrupoECota }}
                <v-tooltip class="elevation-1" color="white" v-if="hasCotas && idCarrinho" top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                                color="primary"
                                small
                                v-bind="attrs"
                                v-on="on"
                                class="ml-1"
                        >
                            mdi-help-circle
                        </v-icon>
                    </template>
                    <span class="text--advice_friendly">{{ cotasText }}</span>
                </v-tooltip>
            </span>
        </div>
        <div class="mb-1">
            <div class="text--advice_friendly customer-info__label-text mr-1 pb-1">
                Prazo de comercialização:
            </div>
            <span class="customer-info__value-text">{{ pzComercializacao }}</span>
        </div>
        <expiracao-banner v-if="showExpiracaoBanner" :id-carrinho="idCarrinho" />
    </div>
</template>

<script>
  import { StatusAlocacoes } from '@/plugins/status_alocacoes'
  import ExpiracaoBanner from './ExpiracaoBanner.vue'

  export default {
    name: 'ProdutoColumn',
    components: {
      ExpiracaoBanner
    },
    props: {
      productName: {
        type: String,
        default: '(não informado)'
      },
      productIcon: {
        type: String,
        default: ''
      },
      bemText: {
        type: String,
        default: '-'
      },
      planoText: {
        type: String,
        default: '-'
      },
      grupo: {
        type: [String, Number],
        default: '-'
      },
      pzComercializacao: {
        type: [String, Number],
        default: '-'
      },
      idCarrinho: {
        type: [Number, String],
        required: false
      },
      showExpiracaoBanner: {
        type: Boolean,
        required: false,
        default: false
      },
      pedidos: {
        type: Array,
        default: () => []
      },
      carrinho: {
        type: Object,
        required: false,
        default: null
      }
    },
    computed: {
      hasCotas () {
        if (this.carrinho?.pedidos != null) {
          const algumaCotaOK = this.carrinho.pedidos.some(
            pedido =>
              pedido.status_alocacao &&
              pedido.status_alocacao.status_alocacao === StatusAlocacoes.Alocado
          )
          if (!algumaCotaOK) return false
        }
        if (this.carrinho?.reservas?.length > 0) {
          return this.carrinho.reservas.some(r => r.cd_cota)
        }
        return (
          this.pedidos?.length > 0 &&
          this.pedidos.some(p => p.cd_cota && p.status_alocacao && p.status_alocacao.status_alocacao === StatusAlocacoes.Alocado)
        )
      },
      grupoDisplay () {
        if (!this.grupo || this.grupo === '-') return null
        return this.grupo
      },
      cotaDisplay () {
        if (!this.hasCotas) return null
        if (this.idCarrinho) return 'Múltiplas Cotas'

        if (this.carrinho && this.carrinho.reservas && this.carrinho.reservas.length > 0) {
          return this.carrinho.reservas[0].cd_cota || null
        }

        return this.pedidos[0].cd_cota || null
      },
      displayGrupoECota () {
        const grupo = this.grupoDisplay
        const cota = this.cotaDisplay

        let algumaCotaOK = true
        if (this.carrinho?.pedidos != null) {
          algumaCotaOK = this.carrinho.pedidos.some(
            pedido =>
              pedido.status_alocacao &&
              pedido.status_alocacao.status_alocacao === StatusAlocacoes.Alocado
          )
        } else if (!this.pedidos[0].status_alocacao ||
          (this.pedidos[0].status_alocacao.status_alocacao !== StatusAlocacoes.Alocado)) {
          algumaCotaOK = false
        }

        if (!grupo && !cota) return '-'
        if (grupo && !algumaCotaOK) return `${grupo}/-`
        if (grupo && !cota) return `${grupo}/-`
        if (!grupo && cota) return '-'
        return `${grupo}/${cota}`
      },
      cotasText () {
        if (!this.hasCotas) return ''

        if (this.carrinho && this.carrinho.reservas && this.carrinho.reservas.length > 0) {
          return this.carrinho.reservas
            .filter(({ cd_cota, status_alocacao }) =>
              cd_cota && status_alocacao?.status_alocacao === StatusAlocacoes.Alocado
            )
            .map(r => r.cd_cota)
            .join(', ')
        }

        return this.pedidos
          .filter(({ cd_cota, status_alocacao }) =>
            cd_cota && status_alocacao?.status_alocacao === StatusAlocacoes.Alocado
          )
          .map(p => p.cd_cota)
          .join(', ')
      }
    }
  }
</script>

<style scoped>
.color--primary {
    color: var(--primary);
}
.customer-name__text {
    font-size: 1.6rem;
    font-weight: 700;
}
.customer-info__label-text {
    font-size: 1.3rem;
}
.customer-info__value-text {
    font-size: 1.3rem;
    font-weight: 700;
}
</style>
